import { render, staticRenderFns } from "./AddModule.vue?vue&type=template&id=13b41614&scoped=true"
import script from "./AddModule.vue?vue&type=script&lang=js"
export * from "./AddModule.vue?vue&type=script&lang=js"
import style0 from "./AddModule.vue?vue&type=style&index=0&id=13b41614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b41614",
  null
  
)

export default component.exports